import React from 'react';
import { Select, SelectChangeEvent } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles: any = makeStyles(() => ({
  container: {
    display: 'inline-flex',
    height: 32,
    width: 64,
    '& fieldset': {
      border: 'none'
    },
    '& select': {
      height: 24,
      paddingTop: 8,
      paddingBottom: 8
    },
    '& .Mui-disabled': {
      backgroundColor: 'white'
    }
  }
}));

type BundleCountSelectionProps = {
  maxAvailable: number;
  value: number;
  onChange: (e: SelectChangeEvent) => void;
  disabled: boolean;
};

export const BundleCountSelection: React.FC<BundleCountSelectionProps> = ({
  maxAvailable,
  value,
  onChange,
  disabled
}) => {
  const classes = useStyles();
  const values = Array.from({ length: maxAvailable }, (_, i) => i + 1);
  return (
    <Select
      native
      value={String(value)}
      onChange={onChange}
      className={classes.container}
      disabled={disabled}
    >
      {values.map((v, i) => (
        <option key={i} value={v}>
          {v}
        </option>
      ))}
    </Select>
  );
};
